import React from 'react'
import moment from 'moment'
import DataTableForCustomPaginationRoute from '../../../../components/DataTableForCustomPaginationRoute'
import Container from '../../../../components/Container'
import { INPUT_MASK } from '../../../../common/constants'
import { nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import { apiListPagination } from '../domain/api'

const ServicesCountriesList: React.FC = () => {
  return (
    <Container
      pageTitle="Listagem"
      breadcrumb={breadcrumbList}
      tools={toolsList}
    >
      <DataTableForCustomPaginationRoute
        paginationUrl={apiListPagination()}
        source={nameSource}
        notHasChildren
        headers={headers}
        customHeaders={[
          {
            name: 'Criado em',
            field: 'created_at',
            sortable: false,
            element: item => {
              return (
                <p>
                  {moment(item?.created_at).format(
                    INPUT_MASK.DATE_LOCALE_WITH_TIME
                  )}
                </p>
              )
            }
          },
          {
            name: 'Ativo',
            field: 'active',
            sortable: true,
            element: (item: { active: string }) => (
              <p>{item.active ? 'Sim' : 'Não'}</p>
            )
          }
        ]}
      />
    </Container>
  )
}

export default ServicesCountriesList
